/* tslint:disable */
/* eslint-disable */
/**
 * Změňte.to Admin API
 * Změňte.to Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SurveyFiltersStatusResponseDTO
 */
export interface SurveyFiltersStatusResponseDTO {
    /**
     * 
     * @type {number}
     * @memberof SurveyFiltersStatusResponseDTO
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof SurveyFiltersStatusResponseDTO
     */
    value: string;
}

export function SurveyFiltersStatusResponseDTOFromJSON(json: any): SurveyFiltersStatusResponseDTO {
    return SurveyFiltersStatusResponseDTOFromJSONTyped(json, false);
}

export function SurveyFiltersStatusResponseDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): SurveyFiltersStatusResponseDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'value': json['value'],
    };
}

export function SurveyFiltersStatusResponseDTOToJSON(value?: SurveyFiltersStatusResponseDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'value': value.value,
    };
}

